import { render } from "./MPFClusterConfig.vue?vue&type=template&id=dd9e3a68&scoped=true&ts=true"
import script from "./MPFClusterConfig.vue?vue&type=script&lang=ts"
export * from "./MPFClusterConfig.vue?vue&type=script&lang=ts"

import "./MPFClusterConfig.vue?vue&type=style&index=0&id=dd9e3a68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9e3a68"]])

export default __exports__